import { render, staticRenderFns } from "./order2.vue?vue&type=template&id=34c71a50&scoped=true"
import script from "./order2.vue?vue&type=script&lang=js"
export * from "./order2.vue?vue&type=script&lang=js"
import style0 from "./order2.vue?vue&type=style&index=0&id=34c71a50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c71a50",
  null
  
)

export default component.exports